// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/builds/allgaeuer.fabian/risag.eu/src/pages/index.js"),
  "component---src-pages-kontakt-js": require("gatsby-module-loader?name=component---src-pages-kontakt-js!/builds/allgaeuer.fabian/risag.eu/src/pages/kontakt.js"),
  "component---src-pages-schleiferei-js": require("gatsby-module-loader?name=component---src-pages-schleiferei-js!/builds/allgaeuer.fabian/risag.eu/src/pages/schleiferei.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/builds/allgaeuer.fabian/risag.eu/.cache/json/layout-index.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/builds/allgaeuer.fabian/risag.eu/.cache/json/index.json"),
  "kontakt.json": require("gatsby-module-loader?name=path---kontakt!/builds/allgaeuer.fabian/risag.eu/.cache/json/kontakt.json"),
  "schleiferei.json": require("gatsby-module-loader?name=path---schleiferei!/builds/allgaeuer.fabian/risag.eu/.cache/json/schleiferei.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/builds/allgaeuer.fabian/risag.eu/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js